import moment from 'moment'

// True when both dates are set and parse as valid dates
export const isValidRange = (startDate?: string, endDate?: string) =>
  !!startDate &&
  !!endDate &&
  moment(startDate).isValid() &&
  moment(endDate).isValid()

// Same-length period right before the range; empty strings when the range is invalid
export const getPreviousPeriod = (startDate: string, endDate: string) => {
  if (!isValidRange(startDate, endDate)) return { prevStart: '', prevEnd: '' }

  const durationDays =
    moment(endDate).startOf('day').diff(moment(startDate).startOf('day'), 'days') + 1
  const prevEnd = moment(startDate).subtract(1, 'day').endOf('day').format()
  const prevStart = moment(prevEnd)
    .subtract(durationDays - 1, 'days')
    .startOf('day')
    .format()

  return { prevStart, prevEnd }
}
